"use client";

import { useEffect, useState } from "react";

import { LIGHT_THEME_IDS } from "@/lib/theme";

const INK_PAPER_THEMES = new Set(["ink", "paper"]);

export interface ThemeState {
  theme: string;
  isDark: boolean;
  isInkPaper: boolean;
}

export function useTheme(): ThemeState {
  const [state, setState] = useState<ThemeState>({
    theme: "light",
    isDark: false,
    isInkPaper: false,
  });

  useEffect(() => {
    const update = () => {
      const t = document.documentElement.dataset.theme ?? "light";
      setState((prev) => {
        const next: ThemeState = {
          theme: t,
          isDark: !LIGHT_THEME_IDS.has(t),
          isInkPaper: INK_PAPER_THEMES.has(t),
        };
        if (
          prev.theme === next.theme &&
          prev.isDark === next.isDark &&
          prev.isInkPaper === next.isInkPaper
        ) {
          return prev;
        }
        return next;
      });
    };
    update();
    const obs = new MutationObserver(update);
    obs.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });
    return () => obs.disconnect();
  }, []);

  return state;
}
